import { Link } from "react-router-dom";
import React from "react";
import { MdCurrencyExchange, MdOutlineLaptopChromebook } from "react-icons/md";
import {
  FaDatabase,
  FaAward,
  FaHandHoldingDollar,
  FaMoneyBillTransfer,
  FaArrowTrendUp,
  FaFileCircleCheck,
  FaMoneyBillTrendUp,
  FaFileCircleXmark,
} from "react-icons/fa6";
import { SlCalender } from "react-icons/sl";
import { LuRefreshCw, LuScanFace } from "react-icons/lu";
import { LuUserRoundCheck } from "react-icons/lu";
import { BiTask } from "react-icons/bi";
import { TbUserPin } from "react-icons/tb";
import { MdMobileScreenShare } from "react-icons/md";
import {
  MdCircleNotifications,
  MdOutlineReceiptLong,
  MdOutlineAccessTime,
} from "react-icons/md";
import { SiGoogleforms } from "react-icons/si";
import { Navigation, Autoplay } from "swiper/modules";
import { MdCampaign } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { GiTakeMyMoney } from "react-icons/gi";
import { Helmet } from "react-helmet-async";
import {
  FaFileInvoiceDollar,
  FaFileSignature,
  FaRegCalendarCheck,
  FaUserCheck,
} from "react-icons/fa";
import { FiAlertCircle, FiAlertTriangle } from "react-icons/fi";

const features = [
  {
    title: "Payslip Generator",
    desc: "Create professional payslips with earnings, deductions, salary details, and net pay",
    icon: <FaFileInvoiceDollar size={24} color="#10324F" aria-hidden="true" />,
    link: "/hr-documents/payslip-generator",
    isNew: true,
  },

  {
    title: "Offer Letter",
    desc: "Generate professional offer letters with job details, salary, benefits, and employment terms",
    icon: <FaFileSignature size={24} color="#10324F" aria-hidden="true" />,
    link: "/hr-documents/offer-letter-generator",
    isNew: true,
  },

  {
    title: "Appointment Letter",
    desc: "Create formal appointment letters with employee, job role, salary, and employment details",
    icon: <FaRegCalendarCheck size={24} color="#10324F" aria-hidden="true" />,
    link: "/hr-documents/appointment-letter-generator",
    isNew: true,
  },

  {
    title: "Experience Letter",
    desc: "Generate experience letters with employee tenure, responsibilities, skills, and contributions",
    icon: <FaUserCheck size={26} color="#10324F" aria-hidden="true" />,
    link: "/hr-documents/experience-letter-generator",
    isNew: true,
  },

  {
    title: "Relieving Letter",
    desc: "Create relieving letters with employment, separation, clearance, and authorization details",
    icon: <FaFileCircleCheck size={24} color="#10324F" aria-hidden="true" />,
    link: "/hr-documents/relieving-letter-generator",
    isNew: true,
  },

  {
    title: "Promotion Letter",
    desc: "Generate promotion letters with new designation, effective date, salary changes, and responsibilities",
    icon: <FaArrowTrendUp size={24} color="#10324F" aria-hidden="true" />,
    link: "/hr-documents/promotion-letter-generator",
    isNew: true,
  },
  {
    title: "Salary Increment Letter",
    desc: "Create increment letters with appraisal details, increment amount, percentage, and revised salary",
    icon: <FaMoneyBillTrendUp size={24} color="#10324F" aria-hidden="true" />,
    link: "/hr-documents/salaryincrement-letter-generator",
    isNew: true,
  },
  {
    title: "Salary Revision Letter",
    desc: "Generate salary revision letters with current and revised compensation and effective date",
    icon: <MdCurrencyExchange size={26} color="#10324F" aria-hidden="true" />,
    link: "/hr-documents/salaryrevision-letter-generator",
    isNew: true,
  },
  // {
  //   title: "Confirmation Letter",
  //   desc: "Generate professional confirmation letters to formally confirm an employee's position, employment status, and continued employment with the company.",
  //   icon: <FaFileCircleCheck size={26} color="#10324F" aria-hidden="true" />,
  //   link: "/hr-documents/confirmation-letter-generator",
  //   isNew: true,
  // },

  {
    title: "Warning Letter",
    desc: "Generate professional warning letters to formally address employee misconduct, performance issues, policy violations, or workplace concerns.",
    icon: <FiAlertTriangle size={28} color="#10324F" aria-hidden="true" />,
    link: "/hr-documents/warning-letter-generator",
    isNew: true,
  },

  // {
  //   title: "Show Cause Notice Letter",
  //   desc: "Generate show cause notices asking employees to explain misconduct,policy violations,performance concerns or other disciplinary issues.",
  //   icon: <FiAlertCircle size={28} color="#10324F" aria-hidden="true" />,
  //   link: "/hr-documents/show-cause-notice-letter-generator",
  //   isNew: true,
  // },

  // {
  //   title: "Termination Letter",
  //   desc: "Generate professional termination letters to formally communicate the end of an employee's employment, including the termination reason and effective date.",
  //   icon: <FaFileCircleXmark size={28} color="#10324F" aria-hidden="true" />,
  //   link: "/hr-documents/termination-letter-generator",
  //   isNew: true,
  // },
];

export default function AllLetters() {
  return (
    <>
      <Helmet>
        <title>
          Waggex HRMS Features | Payroll & Attendance Software for HRs
        </title>
        <meta
          name="description"
          content="Explore Waggex HRMS features for payroll, attendance, employee management, compliance, FaceLens, live location, and more for businesses in India."
        />
        <meta
          name="keywords"
          content="HRMS software features, HRMS features, payroll software features, HR software features, payroll management features, employee management software, HRMS software, payroll software"
        />
        <link rel="canonical" href="https://www.waggex.com/all-hr-documents" />
        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        /> */}
      </Helmet>
      <section
        id="OurFeature"
        className="relative overflow-hidden py-10 px-6 bg-[#d3e0eb]"
      >
        {/* Blur dots */}

        <div className="max-w-6xl mx-auto mb-8">
          {/* Section header */}
          <div className="text-center mb-14">
            <h2 className="text-[#10324F] text-xl sm:text-3xl font-roboto font-bold leading-snug uppercase mb-4">
              Create Professional HR Letters for Free
            </h2>

            <p className="section-desc">
              Everything from attendance tracking and payroll processing to
              compliance management organized in one powerful HRMS solution
            </p>
          </div>

          {/* Cards */}
          <div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {features.map((item, index) => (
                <div key={index} className="flex h-full">
                  <div
                    className="relative flex w-full flex-col rounded-[14px] bg-white p-8
        shadow-[0_10px_10px_rgba(13,59,93,0.12)]
        transition-all duration-300
        hover:-translate-y-2
        hover:shadow-[0_16px_40px_rgba(13,59,93,0.18)]"
                  >
                    {item.isNew && (
                      <div className="absolute top-0 right-0 overflow-hidden w-24 h-24 pointer-events-none z-10">
                        <div className="absolute top-4 -right-8 w-32 rotate-45 bg-[#FF0000] text-white text-sm font-bold text-center py-1 shadow-lg uppercase">
                          NEW
                        </div>
                      </div>
                    )}
                    {/* Icon */}
                    <div className="mb-5 flex justify-center">
                      <div
                        className="flex h-16 w-16 items-center justify-center
            rounded-xl bg-white
            shadow-[0_6px_20px_rgba(13,59,93,0.15)]"
                      >
                        {item.icon}
                      </div>
                    </div>

                    {/* Title */}
                    <h2 className="mb-3 text-center text-lg font-semibold text-[#10324F]">
                      {item.title}
                    </h2>

                    {/* Description */}
                    <p className="mb-6 flex-1 text-center text-sm leading-[180%] text-[#10324F]">
                      {item.desc}
                    </p>

                    {/* Button */}
                    <Link
                      onClick={() => {
                        window.location.href = item.link;
                      }}
                      className="mt-1 rounded-md border border-[#D1DFEA]
          bg-[linear-gradient(180deg,rgba(209,223,234,0.052)_50.18%,rgba(209,223,234,0.2)_100%)]
          px-6 py-3 text-center text-[15px] font-medium text-[#10324F]
          shadow-[0_6px_18px_rgba(0,0,0,0.12)]
          transition-all duration-200
          hover:-translate-y-0.5
          hover:shadow-[0_10px_24px_rgba(0,0,0,0.16)]"
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
